<template>
    <div v-if="meetup" class id="printable">
        <cm-back
            sectionTitle="QR code for checkin"
            :contentName="meetup ? meetup.name : 'Loading...'"
            :to="{name: 'manage', query: {view: 'meetups'}}"
            action
        ></cm-back>
        <div class="container">
            <div class="d-flex justify-content-center flex-column align-items-center">
                <div class="d-flex justify-content-center">
                    <p
                        class="link mt-3"
                        @click="showHint = !showHint"
                    >{{showHint ? "Hide" : "Show"}}</p>
                </div>
                <b-collapse id="qr-hint" v-model="showHint" class="mt-2">
                    <warning
                        class="mb-3"
                    >Show this to your attendees the day of your event: they'll be able to scan it with the Codemotion app and confirm their participation.</warning>
                </b-collapse>
                <h4 class="mb-2 mb-0">Scan to Checkin</h4>
                <qrcode
                    ref="qr"
                    id="qr-code"
                    tag="img"
                    :value="`https://www.codemotion.com/downloadapp.php?hash=${meetup.hash}`"
                    :options="{ width: 450 }"
                ></qrcode>
                <a :href="qrUrl" download>
                    <button class="btn btn-outline-success px-3 my-3">download QR code</button>
                </a>
            </div>
        </div>
    </div>
    <div v-else class="w-100 d-flex justify-content-center p-5">
        <b-spinner></b-spinner>
    </div>
</template>
<script>
import CmBack from "@/components/CmBack.vue";
import Warning from "@/components/Warning.vue";
export default {
    name: "meetup-qr",
    components: {
        CmBack,
        Warning
    },
    async mounted() {
        if (!this.meetup) {
            try {
                const community = await this.$communityApi.getCommunity(
                    this.$route.params.id
                );
                this.$store.commit("setCommunity", community);
            } catch (error) {
                console.error(error);
                this.$router.push("/communities#management");
                return;
            }
            try {
                const meetup = await this.$meetupApi.getMeetupById(
                    this.$route.params.meetupid
                );
                this.$store.commit("setMeetup", meetup.data);
            } catch (error) {
                console.error(error);
            }
        }
        this.qr = document.getElementById("qr-code");
    },
    data: () => ({
        qr: null,
        showHint: true
    }),
    computed: {
        qrUrl() {
            if (this.qr) return this.qr.getAttribute("src");
            return "";
        },
        community() {
            return this.$store.getters.community;
        },
        meetup() {
            return this.$store.getters.meetup;
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/common";

#qr-code {
    height: 300px;
}
</style>